<template>
  <el-container class="container" id="recibo-pdf">
    <el-col
      :xs="24"
      :sm="20"
      :md="22"
      :lg="20"
      :xl="20"
    >
      <el-row
        class="hide-on-print header-actions" type="flex"
        justify="center"
      >
        <el-button @click="$goBack()">
          Volver
        </el-button>
        <router-link to="/busqueda-del-predio" style="margin: 0px 10px">
          <el-button>
            Consultar otra cuenta
          </el-button>
        </router-link>
      </el-row>
      <el-col :span="24" class="frame-container">
        <iframe
          name=""
          class="doc"
          :src="receipt.reciboPDF && !receipt.reciboPDF.startsWith('data:') ? `data:application/pdf;base64,${receipt.reciboPDF}` : receipt.reciboPDF"
          frameborder="0"
        />
      </el-col>
    </el-col>
  </el-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      receipt: (state) => state.receipt,
    }),
  },
};
</script>

<style lang="scss" scoped>
.container {
  font-size: 12px;
  justify-content: center;
  padding: 0;
  overflow-x: hidden;
  * {
    font-family: Arial;
  }
  text {
    font-weight: bold !important;
  }
  .general {
    p {
      margin: 5px 0;
    }
    b {
      font-size: 10px;
    }
  }
  .badge-title {
    color: White;
    background-color: #B9A5CB;
    font-weight: bold;
    font-size: 16px;
    border-radius: 15px;
    text-align: center;
    padding: 3px;
    margin: 5px 0;
    width: 100%;
    a.link {
      text-decoration: none;
      color: #FFFFFF;
    }
  }
  .dark, .light {
    padding: 10px;
    display: flex;
    flex-direction: row;
  }
  .dark {
    font-size: 9px;
    background-color: #856BAD;
    justify-content: space-between;
    font-weight: 500;
  }
  .light {
    font-size: 12px;
    background-color: #C6A6DF;
    font-weight: bold;
    justify-content: space-around;
  }
  .el-button {
    background-color: #956FA8;
    color: #FFFFFF;
  }
  .thanks {
    width: 50%;
  }
  .top-banner {
    width: 100%;
  }
  .content {
    font-size: 9px;
    padding: 1px;
    font-weight: bold;
  }
  .caption {
    color: #330066;
    font-family: Arial;
    font-size: 8pt;
    font-weight: bold;
    text-align: justify;
  }
  .info {
    color: #330066;
    font-family: Arial;
    font-size: 8pt;
    text-align: justify;
  }
  .adeudos {
    position: relative;
    .el-row .el-col {
      font-family: Arial;
      font-size: 8pt;
    }
    .el-row .el-col:nth-child(1) {
      p {
        font-weight: bold;
      }
    }
    .el-row .el-col:nth-child(2) {
      p {
        text-align: end;
        // width: 50px;
      }
    }
    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 5%;
      width: 90%;
      height: 5px;
      background-color: #C3A4CC;
    }
  }
  .page-braker {
    height: 300px;
  }
  .payments {
    .payment {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      padding-right: 10px;
      &:nth-child(1):after, &:nth-child(3):after {
        content: '';
        background-color: #B289FA;
        position: absolute;
        right: -15px;
        width: 1px;
        top: 35%;
        bottom: 35%;
      }
      .adeudo {
        width: 100%;
        p:last-of-type {
          text-align: center;
        }
        .el-col:nth-child(2) {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 26px;
          margin-bottom: 10px;
        }
        center {
          height: 70px;
        }
      }
    }
    .qr {
      padding: 10px 20px 20px 20px;
    }
    #barCode1, #barCode2, #barCode3, #barCode4 {
      height: 80px;
    }
  }
  .banner {
    margin-top: 15px;
    img {
      width: 100%;
    }
  }
}
.frame-container {
  margin-top: 20px;
  .doc {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 180px);
  }
}
@media only screen and (max-width: 767px) {
  .payments {
    flex-direction: row !important;
    .payment:nth-child(1):after, .payment:nth-child(3):after {
      content: '';
      position: absolute;
      width: 0 !important;
    }
  }
}
@media only screen and (max-width: 520px) {
  .header-actions {
    flex-direction: column !important;
    a, button {
      width: 100%;
      margin: 2.5px 0px !important;
    }
  }
  .payments {
    display: flex;
    flex-direction: column !important;
    width: 100%;
    .payment {
      width: 100%;
    }
  }
  .bank {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin: 5px 0;
    }
  }
  .dark {
    flex-direction: column !important;
  }
  .banner {
    margin-top: 15px;
    img {
      width: 100%;
      margin-bottom: 100px;
    }
  }
  .page-break {
    height: 350px;
  }
}
</style>

<style lang="scss">
@media print {
  .hide-on-print, .header {
    display: none;
  }
  .adeudos {
    .el-row {
      .el-col.el-col-offset-1 {
        max-width: 120px;
      }
    }
  }
  .page-break {
    page-break-before: always;
  }
  .payments {
    padding-top: 25px;
    flex-direction: row !important;
    .payment {
      width: 45% !important;
    }
  }
  .el-main {
    padding: 0px;
  }
}

</style>
